export default {
  "nl": {
    "analytics": {
      "labels": {
        "click_seen_by": "Klik om te weten welke klanten dit reeds hebben gezien",
        "click_shared_with": "Klik om te weten met welke klanten dit gedeeld is",
        "deleted": "Verwijderd",
        "deleted_item": "Dit item is verwijderd en is niet meer klikbaar",
        "noCustomers": "Nog geen klanten toegewezen aan dit niveau",
        "noCustomersSeen": "Nog geen enkele klant heeft dit gezien",
        "noCustomersUnseen": "Alle klanten hebben dit gezien",
        "noUnitAccess": "Geen toegang tot unit",
        "notSeen": "Nog niet gezien ({number})",
        "seen": "Gezien ({number})",
        "seenBy": "Gezien door",
        "sharedWithMultipleUnits": "Gedeeld met 0 klanten in {level_name} | Gedeeld met 1 klant in {level_name} | Gedeeld met {customers_count} klanten in {level_name}",
        "sharedWithUnit": "Gedeeld met {unit_name}",
        "units": "Geen Unit | 1 Unit | {count} Units",
        "views": "Gezien door",
        "viewsCount": "Nog niet gezien | 1 gezien | {count} gezien"
      }
    }
  }
}